import React from 'react';

import AgentContextProvider from './AgentContextProvider';
import AuthContextProvider from './AuthContextProvider';
import ConfigContactModal, { ConfigContactModalProps } from '../index';

type ConfigContactModalAngularComponentProps = {
  $rootScope: any;
} & ConfigContactModalProps;

export const ConfigContactModalAngularComponent: React.FC<
  ConfigContactModalAngularComponentProps
> = ({ $rootScope, ...props }) => (
    <AuthContextProvider auth={$rootScope.auth}>
      <AgentContextProvider fetchOrgUsers={$rootScope.fetchOrgUsers}>
        <ConfigContactModal
          {...props}
          setChatVisibility={$rootScope.setChatVisibility}
        />
      </AgentContextProvider>
    </AuthContextProvider>
  );
